module.exports = __webpack_public_path__ + "img/en.1c4f69ae.png";